export default "__VITE_ASSET__CsWanJwT__"